import { gql } from '@apollo/client';
export const StatFeatureLeaveRanges = gql `
    fragment StatFeatureLeaveRanges on LeaveRangeFeatureSettingsFlags {
        enabled
    }
`;
